import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@store/auth/auth.state';
import { Permission } from '../../types/permission';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private readonly store: Store) {}
  hasAuthoritySignal(permission: Permission) {
    return this.store.selectSignal(AuthState.hasAuthority(permission));
  }

  hasAuthorityStream(permission: Permission) {
    return this.store.select(AuthState.hasAuthority(permission));
  }

  hasAuthority(permission: Permission) {
    return this.store.selectSnapshot(AuthState.hasAuthority(permission));
  }
}
